<template>
  <div id="diy-dialog-import-result">
    <!-- 导入数据回显 -->
    <div class="line">
      <div class="title">
        <div class="tip"></div>
        成功数量
      </div>
      <div class="value">{{ importResultData.successData.num }}</div>
    </div>
    <div class="line-table">
      <div class="title">
        <div class="tip"></div>
        相似数量<span>{{ importResultData.similData.num }}</span>
      </div>
      <div class="table">
        <el-table
          :data="importResultData.similData.data"
          border
          style="width: 100%"
          height="450"
        >
          <el-table-column prop="topicnType" label="题型"> </el-table-column>
          <el-table-column prop="questionStem" label="题干"> </el-table-column>
          <el-table-column prop="similQuestDataStem" label="相似题干">
          </el-table-column>
          <el-table-column prop="similarity" label="相似度"> </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="line-table">
      <div class="title">
        <div class="tip"></div>
        失败数量 <span>{{ importResultData.errorData.num }}</span>
      </div>
      <div class="table">
        <el-table
          :data="importResultData.errorData.data"
          border
          style="width: 100%"
          height="450"
        >
          <el-table-column prop="name" label="题干"> </el-table-column>
          <el-table-column prop="reason" label="失败原因"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_import_result",
  props: {
    importResultData: {
      type: Object,
      default: function () {
        return {
          successData: {
            //成功数据
            num: 0,
            data: [],
          },
          errorData: {
            // 失败数据
            num: 0,
            data: [],
          },
          similData: {
            // 相似数据
            num: 0,
            data: [],
          },
        };
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
#diy-dialog-import-result {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > .line {
    width: 100%;
    height: auto;
    display: flex;
    margin-bottom: 10px;
    > .title {
      width: auto;
      margin-right: 5px;
      height: auto;
      line-height: 35px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 15px;
      font-weight: bold;
      > .tip {
        width: 3px;
        height: 25px;
        background-color: #ff6a25;
        margin-right: 10px;
        margin-left: 10px;
      }
    }
    > .value {
      width: 0;
      flex: 1;
      line-height: 35px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-right: 20px;
      font-size: 15px;
      font-weight: bold;
    }
  }
  > .line-table {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-right: 20px;
      font-size: 15px;
      font-weight: bold;
      > .tip {
        width: 3px;
        height: 25px;
        background-color: #ff6a25;
        margin-right: 10px;
        margin-left: 10px;
      }
      > span {
        margin-left: 5px;
      }
    }
  }
}
</style>